export default function (user) {
    let result;
  
    if (process.env.VUE_APP_REGION === 'US') {
        result = user.platformRole
        ? user.platformRole
            .replace(/-/g, ' ')  // Replace hyphens with spaces
            .split(' ')          // Split into words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize each word
            .join(' ')           // Join back into a single string
        : user.role.charAt(0).toUpperCase() + user.role.slice(1); // Fallback to user.role if no platformRole
    } else {
      // Capitalize the first letter of user.role
      result = user.role.charAt(0).toUpperCase() + user.role.slice(1);
    }
  
    return result;
  }
  